import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getNativeRequired } from "../../../../anyspend/utils/chain.js";
import { isNativeToken } from "../../../../anyspend/utils/token.js";
import { useSimTokenBalance } from "../../../../global-account/react/index.js";
import { formatTokenAmount } from "../../../../shared/utils/number.js";
import { useMemo } from "react";
import { formatUnits } from "viem";
export function TokenBalance(t0) {
  const $ = _c(21);
  const {
    token,
    walletAddress,
    onChangeInput
  } = t0;
  const tokenAddress = isNativeToken(token.address) ? "native" : token.address;
  const {
    data,
    isLoading
  } = useSimTokenBalance(walletAddress, tokenAddress, token.chainId);
  let t1;
  bb0: {
    const balance = data?.balances?.[0];
    if (!balance?.amount) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          rawBalance: null,
          formattedBalance: "0"
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    let t3;
    if ($[1] !== balance.amount || $[2] !== balance.decimals) {
      const raw = BigInt(balance.amount);
      t2 = raw;
      t3 = formatTokenAmount(raw, balance.decimals);
      $[1] = balance.amount;
      $[2] = balance.decimals;
      $[3] = t2;
      $[4] = t3;
    } else {
      t2 = $[3];
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
      t4 = {
        rawBalance: t2,
        formattedBalance: t3
      };
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t1 = t4;
  }
  const {
    rawBalance,
    formattedBalance
  } = t1;
  let t2;
  if ($[8] !== onChangeInput || $[9] !== rawBalance || $[10] !== token.address || $[11] !== token.chainId || $[12] !== token.decimals) {
    t2 = percentage => {
      if (!rawBalance) {
        return;
      }
      let amount;
      if (percentage === 100) {
        if (isNativeToken(token.address)) {
          const gasReserve = getNativeRequired(token.chainId);
          amount = rawBalance > gasReserve ? rawBalance - gasReserve : BigInt(0);
        } else {
          amount = rawBalance;
        }
      } else {
        amount = rawBalance * BigInt(percentage) / BigInt(100);
      }
      onChangeInput(formatUnits(amount, token.decimals));
    };
    $[8] = onChangeInput;
    $[9] = rawBalance;
    $[10] = token.address;
    $[11] = token.chainId;
    $[12] = token.decimals;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const handlePercentageClick = t2;
  let t3;
  if ($[14] !== formattedBalance || $[15] !== handlePercentageClick || $[16] !== isLoading || $[17] !== rawBalance || $[18] !== token.address || $[19] !== token.chainId) {
    t3 = _jsx("div", {
      className: "flex h-7 items-center justify-end gap-1",
      children: !isLoading && _jsxs(_Fragment, {
        children: [_jsx("div", {
          className: "text-as-primary/50 inline-flex rounded-lg text-sm",
          children: rawBalance ? `Balance: ${formattedBalance}` : `Balance: 0`
        }), !!rawBalance && _jsx(_Fragment, {
          children: _jsx("button", {
            onClick: () => handlePercentageClick(100),
            className: "text-as-primary/50 bg-as-on-surface-2 hover:bg-as-on-surface-3 inline-flex cursor-pointer rounded-lg px-2 py-1 text-xs transition-colors",
            children: "MAX"
          })
        })]
      })
    }, `balance-${token.address}-${token.chainId}`);
    $[14] = formattedBalance;
    $[15] = handlePercentageClick;
    $[16] = isLoading;
    $[17] = rawBalance;
    $[18] = token.address;
    $[19] = token.chainId;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}